import { useApi } from '../services';

export const useSavePersonRelationships = (idPerson) => useApi(`v2/person/${idPerson}/person-relationship`, 'POST', {}, {}, true);

export const useUpdatePersonRelationshipsHierarchy = (idPerson) => useApi(`v2/person/${idPerson}/person-relationship/hierarchy`, 'PUT', {}, {}, true);

